import React from "react";
import About_Banner from "./about-banner/About_Banner";
import Vision_Mission_Value from "./vision-mission-value/Vision_Mission_Value";
import What_Customer_Say from "../home/what-customer-say/What_Customer_Say";
import How_we_work from "../home/how_we_work/How_we_work";
import Become_a_dealer from "../home/become_a_dealer/Become_a_dealer";
import { Helmet } from "react-helmet-async";

const About_Us = () => {
  return (
    <>
      <Helmet>
        <title>About AYZAIR | Trusted Industrial Air Compressor Company</title>
        <meta
          name="title"
          content="About AYZAIR | Trusted Industrial Air Compressor Company"
        />
        <meta
          name="description"
          content="Learn about AYZAIR, a trusted provider of industrial air compressors, compressed air systems, and innovative air treatment solutions for diverse industries."
        />
          <link rel="canonical" href={"https://www.ayzair.com/about-us"} />
      </Helmet>

      <About_Banner />
      <Vision_Mission_Value />
      <How_we_work />
      {/* <Man_Behind_The_Power /> */}
      <Become_a_dealer />
      <What_Customer_Say />
    </>
  );
};

export default About_Us;
